import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { DistrictService } from '../../services/district.service';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { ValidationService } from '../../services/validation.service';
import { TableDropdownComponent } from '../../components/table-dropdown/table-dropdown.component';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-head-evaluator-mapping-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ModalComponent, ReactiveFormsModule, FormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, SearchInputComponent, FilterByKeyAndValuePipe],
  templateUrl: './head-evaluator-mapping-list-page.component.html',
  styleUrl: './head-evaluator-mapping-list-page.component.css'
})
export class HeadEvaluatorMappingListPageComponent {
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('list') list: AgGridListComponent | undefined;
  page_name = 'Assign Head Evaluator';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  subject_id: number | null = null;
  filtered_head_evaluator_list: any[] = [];

  columns: any = [];

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ds: DistrictService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService, public us: UserService) {
    this.form = this.fb.group({
      head_evaluator_id: ['', [Validators.required]],
    });
  }

  async ngOnInit() {
    await this.dds?.get_dropdown_list(['university', 'subject', 'head_evaluator']);

    this.initializeColumns();

    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      if (this.params.subject_id) {
        await this.get_list(this.params)
      }
    })
  }

  initializeColumns() {
    this.columns = [
      { field: 'name', headerName: 'Evaluator Name', filter: true, flex: 1, },
      {
        headerName: 'Evaluator Details', filter: true, flex: 1,
        cellRenderer: (p: any) => {
          const contact = p.data?.contact ? `+91 ${p.data.contact}` : '';
          const email = p.data?.email || '';
          return `<div class="flex flex-col justify-center h-full"><span class="font-medium text-gray-800 text-sm">${contact}</span><span class="text-gray-500 text-xs mt-0.5">${email}</span></div>`;
        }
      },

      {
        field: 'view_to', headerName: 'View To', filter: true, flex: 1,
        cellRenderer: (params: any) => {
          const value = params.data?.view_to || 'Everyone';
          const isAssigned = value === 'Assigned';
          return `<div class="flex items-center h-full"><span class="inline-block px-5 py-1.5 rounded-full text-sm font-semibold ${isAssigned ? 'bg-green-100 text-[#1a7a4a]' : 'bg-[#F7F7F7] text-gray-500'}">${value}</span></div>`;
        }
      },
      {
        headerName: 'HE Contact', filter: true, flex: 1,
        valueGetter: (p: any) => p.data?.HeadEvaluator?.contact ? `+91 ${p.data.HeadEvaluator.contact}` : '',
      },
      {
        field: 'HeadEvaluator.id',
        headerName: `Head Evaluator`,
        flex: 1,
        valueGetter: (params: any) => params.data?.HeadEvaluator?.id || params.data?.head_evaluator_id,
        cellRenderer: TableDropdownComponent,
        cellRendererParams: {
          disabled: !this.gs.user_role_data?.assignments_assign_evaluation_assign,
          options: this.filtered_head_evaluator_list.length > 0 ? this.filtered_head_evaluator_list : this.dds.dropdown_list?.head_evaluator_list,
          label: ``,
          placeholder: `Assign Manually`,
          show_email: true,
          onChange: this.onEvaluatorChange.bind(this)
        }
      },
    ];
  }

  /* Dropdown Dependency Logic */
  dropdownRegistry: { [depended: number]: any } = {};

  registerDropdown(event: { depended: number; ref: any }) {
    this.dropdownRegistry[event.depended] = event.ref;
  }

  async onDropdownChange(event: { value: any, depended: number }) {
    console.log("Dropdown changed:", event);

    const queryParams: any = { ...this.params };

    if (event.depended == 1) {
      if (event.value) {
        queryParams.university_id = event.value.value;
      } else {
        delete queryParams.university_id;
      }
      delete queryParams.subject_id;
      this.items = [];
    }
    if (event.depended == 2) {
      if (event.value) {
        queryParams.subject_id = event.value.value;
      } else {
        delete queryParams.subject_id;
        this.items = [];
      }
    }

    // Update Query Params
    this.route.navigate([], {
      relativeTo: this.ar,
      queryParams: queryParams,
    });

    const current = event.depended;
    for (const key of Object.keys(this.dropdownRegistry).map(Number)) {
      if (key > current) {
        this.dropdownRegistry[key]?.reset();
      }
    }
  }

  async onEvaluatorChange(new_value: any, row_data: any) {
    console.log('Head Evaluator changed:', new_value, 'for row:', row_data);
    try {
      if (row_data.id) {
        await this.us.assignHeadEvaluator(row_data.id, { head_evaluator_id: new_value, view_to: row_data.view_to == 'Everyone' ? 'Assigned' : 'Everyone' });
        await this.get_list(this.params); // Refresh the list to show updated head evaluator
        this.gs.toastr_shows_function('Head Evaluator Mapping Updated Successfully', 'Success', 'success');
      }
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || 'Error updating Head Evaluator', 'Error', 'error');
    }
  }

  async get_list(filter?: any) {
    try {
      if (this.params.subject_id) {
        // Set subject_id directly from params
        this.subject_id = this.params.subject_id;

        const res = await this.us.get_list({
          ...filter,
          subject_id: this.params.subject_id,
          user_type: 'staff',
          evaluator: true
        });
        const page = filter?.page || 1;
        const pagesize = filter?.page_size || 10;
        const startindex = (page - 1) * pagesize;
        res.data = res.data.map((item: any, index: number) => ({
          ...item,
          SrNo: startindex + index + 1,
          view_to: item.view_to == null ? 'Everyone' : item.view_to
        }));
        this.items = res;

        // Load filtered head evaluators by subject
        if (this.subject_id) {
          await this.load_head_evaluators_by_subject();
        }
      }
    } catch (error: any) {
      console.error("Error fetching User list:", error);
    }
  }

  async load_head_evaluators_by_subject() {
    if (this.subject_id) {
      this.filtered_head_evaluator_list = await this.dds.get_evaluators_by_subject(this.subject_id, 'head_evaluator');
      // Update column definitions with new head evaluator list
      this.initializeColumns();
    }
  }

  async open_form_modal() {
    this.form.reset();
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please select a head evaluator', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }

      const head_evaluator_id = this.form.value.head_evaluator_id;
      const selectedRows = this.list?.gridApi?.getSelectedRows();

      if (!selectedRows || selectedRows.length === 0) {
        this.gs.toastr_shows_function('No evaluators selected', 'Error', 'error');
        return;
      }

      const promises = selectedRows.map((row: any) =>
        this.us.assignHeadEvaluator(row.id, { head_evaluator_id: head_evaluator_id, view_to: 'Assigned' })
      );

      await Promise.all(promises);

      this.gs.toastr_shows_function('Head Evaluator assigned successfully', 'Success', 'success');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || 'Error assigning head evaluator', 'Error', 'error');
    }
  }
}
